import { Radio, RadioProps } from '@mui/material'

const EcnRadio = (props: RadioProps) => {
  return (
    <Radio {...props} />
  )
}

export default EcnRadio